export default __webpack_public_path__ + "static/duckbill-group-633558fcbcea189129096c468b129f77.svg";